export default "__VITE_ASSET__zALEB6r4__"